module.exports = __webpack_public_path__ + "img/vaziuokle.2f86df8e.jpeg";